import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import * as styles from "./styles";

export function Title({ title }: { title?: string | boolean }) {
  const { t } = useTranslation("localContent");

  const displayTitle = useMemo(
    () =>
      typeof title === "string" && title.length > 0
        ? title
        : t("sidebar.header.title"),
    [title, t]
  );

  return (
    <h2
      className={styles.container}
      aria-label={displayTitle}
      data-testid="sidebar-header-title"
    >
      {title === false ? "" : displayTitle}
    </h2>
  );
}
